import React from 'react'

export const PlusIcon = (props) => (
    <svg style={props.style} width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3.91162" y="0.84375" width="1.06636" height="7.88411" fill={props.fill ? props.fill : "#F6F6F6"}/>
        <rect x="8.3916" y="4.25195" width="1.06636" height="7.88411" transform="rotate(90 8.3916 4.25195)" fill={props.fill ? props.fill : "#F6F6F6"}/>
    </svg>
)
